"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.assert = exports.AssertionError = exports.assign = exports.values = exports.fromEntries = exports.entries = exports.keys = void 0;
/**
 * An alternative, stricter typed version of `Object.keys`.
 * @param object The object to get the keys from.
 * @returns The keys of the object.
 */
function keys(object) {
    return Object.keys(object);
}
exports.keys = keys;
/**
 * An alternative, stricter typed version of `Object.entries`.
 * @param object - The object to get the entries of.
 * @returns An array of tuples of the object's keys and values.
 */
function entries(object) {
    return Object.entries(object);
}
exports.entries = entries;
/**
 * An alternative, stricter typed version of `Object.fromEntries`.
 * @param entries - The entries to convert to an object.
 * @returns An object with the entries' keys and values.
 */
function fromEntries(entries) {
    return Object.fromEntries(entries);
}
exports.fromEntries = fromEntries;
/**
 * An alternative, stricter typed version of `Object.values`.
 * @param object - The object to get the values of.
 * @returns An array of the object's values.
 */
function values(object) {
    return Object.values(object);
}
exports.values = values;
/**
 * An alternative to `Object.assign`, which asserts that the properties are added to the type.
 * @param target - The object to add the properties to.
 * @param source - The object to get the properties from.
 */
function assign(target, source) {
    Object.assign(target, source);
}
exports.assign = assign;
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AssertionError;
}(Error));
exports.AssertionError = AssertionError;
/**
 * Asserts that a condition is true.
 * Any code after this assertion will consider the condition to be true.
 * See https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-7.html#assertion-functions
 *
 * @param condition - The condition to assert.
 * @param message - The message to throw if the condition is false.
 * @example
 * // Before, 'value' is of an unknown type.
 * assert(typeof value === 'string')
 * // After, 'value' is known to be a string.
 */
function assert(condition, message) {
    if (!condition) {
        throw new AssertionError(message);
    }
}
exports.assert = assert;
